import { Dispatch, SetStateAction, createContext, useContext } from "react";

export interface IUserData {
  isLoggedIn: boolean;
  setIsLoggedIn: Dispatch<SetStateAction<boolean>>;
  name: string|null;
  setName: Dispatch<SetStateAction<string|null>>;
}
export const UserContext = createContext<IUserData>({ isLoggedIn: false, setIsLoggedIn: () => { }, name: "", setName: () => { } });
export const useUserContext = () => useContext(UserContext);